import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DeleteCreditsModal } from '../../delete-credits/delete-credits.modal';

@Component({
  selector: 'app-creditListItem',
  templateUrl: './creditlistitem.component.html'
})
export class CreditListItemComponent {
  private _organisationCredit!: any;
  @Input() set organisationCredit(val: any){
    val.expired = new Date(val.validUntil).getTime() < new Date().getTime();
    val.used = !val.active && !val.expired && val.remaining == 0;
    this._organisationCredit = val;
    this._organisationCredit.status = "InActive";
    if(val.active) this._organisationCredit.status = "Active";
    else if(val.used) this._organisationCredit.status = "Used";
    else if(val.expired) this._organisationCredit.status = "Expired";
    else if(!val.active && !val.expired && !val.used) this._organisationCredit.status = "InActive";
  }
  get organisationCredit(): any {
    return this._organisationCredit;
  }

  @Input() NotAllowedToAddOrDeleteCredits: boolean = true;
  @Output() deleteCreditBundle: EventEmitter<string> = new EventEmitter<string>();

  constructor(private modalService: NgbModal) {
    // Must not be empty. It's approved by a comment.
  }

  delete() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      windowClass: 'dialog-bg-white'
    };
    const modalRef = this.modalService.open(DeleteCreditsModal, ngbModalOptions);
    modalRef.componentInstance.creditGuid = this.organisationCredit.guid;
    modalRef.closed.subscribe({
      next: (value: any) => {
        if (value === false) return;
        if (value != null && value != "") {
          this.deleteCreditBundle.emit(this.organisationCredit.guid);
        }
      }
    });
  }
}
